import React from 'react';
import Sensors from './Sensors';
import type { SensorsProps } from './types';

const SensorsPage: React.FC<SensorsProps> = (props) => {
  return <Sensors {...props} />;
};

export default SensorsPage;
